import { atom } from 'recoil';
import { FilterDef } from '../../../../constants/FinanceModels';

export const STATE_TABLE_UPDATING = atom<boolean>({
    key: "sdd-receipts-detail-state-table-updating",
    default: false
});

export const STATE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'sdd-receipts-detail-state-active-filters',
    default: []
});